'use strict';
import {combineReducers} from 'redux';
import {PEOPLE_LIST_NAME, PEOPLE_SELECTOR_LIST_NAME, PEOPLE_SELECTOR_MODAL_NAME} from '../redux/state';
import {reduxList as peopleList} from '../redux/peopleList';
import {reduxList as peopleSelectorList} from '../redux/peopleSelectorList';
import {reactReduxModal as peopleSelectorModal} from '../redux/peopleSelectorModal';

export * from './state';

export const personnel = combineReducers({
  [PEOPLE_LIST_NAME]: peopleList.reducers.reducer,
  [PEOPLE_SELECTOR_LIST_NAME]: peopleSelectorList.reducers.reducer,
  [PEOPLE_SELECTOR_MODAL_NAME]: peopleSelectorModal.reducers.reducer,
});



// WEBPACK FOOTER //
// ./src/js/personnel/reducers/index.js